// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"67e0743d","151":"107ae55a","242":"cce95658","253":"17ad3014","340":"03e9029d","427":"3afbc8e8","565":"a1adafb8","680":"181e597e","918":"7661502d"}[chunkId] + ".chunk.css";
};